import type { CancellationPolicy } from './types';

/** The board's policy — 24 hours, $50, soft guilt, 2 attempts, 15-minute hold. */
export const CANCELLATION_POLICY: CancellationPolicy = {
  noticeHours: 24,
  lateFeeCents: 5000,
  tone: 'soft',
  rescheduleAttempts: 2,
  offerNextSlot: true,
  neverQuoteFeeInPain: true,
  handToGapFiller: true,
  holdMinutes: 15,
};
